// src/frontend/js/modern/ui/image-fix-handler.js
export class ImageFixHandler {
	constructor() {
		this._observer = null;
		this._movedElements = new WeakSet();
		this._debounceTimer = null;
		this._DEBOUNCE_MS = 150;
		this._rafId = null;
	}

	init() {
		this._fixTopOfImage();
		this._fixPowerPack();
		this._setupObserver();
	}

	_fixTopOfImage() {
		document.querySelectorAll('.woocommerce-product-gallery__wrapper .wlfmc-top-of-image').forEach(el => {
			if (this._movedElements.has(el)) return;
			const parentEl = el.parentElement;
			if (parentEl && parentEl.parentElement) {
				parentEl.after(el);
				this._movedElements.add(el);
			}
		});
	}

	_fixPowerPack() {
		document.querySelectorAll('.pp-single-product').forEach(container => {
			const topImage = container.querySelector('.entry-summary > .wlfmc-top-of-image');
			const image = container.querySelector('.entry-summary .single-product-image');
			if (topImage && image) {
				image.appendChild(topImage);
			}
		});
	}

	_setupObserver() {
		if (this._observer) this._observer.disconnect();
		this._observer = new MutationObserver((mutations) => {
			if (this._debounceTimer) clearTimeout(this._debounceTimer);

			this._debounceTimer = setTimeout(() => {
				if (this._rafId) cancelAnimationFrame(this._rafId);
				this._rafId = requestAnimationFrame(() => {
					this._fixTopOfImage();
					this._fixPowerPack();
					this._rafId = null;
				});
				this._debounceTimer = null;
			}, this._DEBOUNCE_MS);
		});
		this._observer.observe(document.body, {
			childList: true,
			subtree: true,
		});
	}

	destroy() {
		if (this._observer) { this._observer.disconnect(); this._observer = null; }
		if (this._debounceTimer) { clearTimeout(this._debounceTimer); this._debounceTimer = null; }
		if (this._rafId) { cancelAnimationFrame(this._rafId); this._rafId = null; }
	}
}
